import type { CupomFiscalItem, Filtros } from "../models/emissaoCupomFiscalModel"

export enum EmissaoCupomFiscalActionsTypes {
    CARREGAR = "CARREGAR",
    SET_FILTRO = "SET_FILTRO",
}

export type EmissaoCupomFiscalAction =
    | { type: EmissaoCupomFiscalActionsTypes.CARREGAR; payload: CupomFiscalItem[] }
    | { type: EmissaoCupomFiscalActionsTypes.SET_FILTRO; payload: Partial<Filtros> }
